const clientLogos = [
  { src: 'https://99-marketing.com/wp-content/themes/marketing/assets/img/clients/abtropical.com.png', alt: 'AB Tropical' },
  { src: 'https://99-marketing.com/wp-content/themes/marketing/assets/img/clients/carolinamoldexperts.com.jpg', alt: 'Carolina Mold Experts' },
  { src: 'https://99-marketing.com/wp-content/themes/marketing/assets/img/clients/carriagepinstriping.com.png', alt: 'Carriage Pinstriping' },
  { src: 'https://99-marketing.com/wp-content/themes/marketing/assets/img/clients/coastaldermatologyandplasticsurgery.com.png', alt: 'Coastal Dermatology' },
  { src: 'https://99-marketing.com/wp-content/themes/marketing/assets/img/clients/ecosenvironmental.com.png', alt: 'Ecos Environmental' },
  { src: 'https://99-marketing.com/wp-content/themes/marketing/assets/img/clients/eliterelocationsd.com.png', alt: 'Elite Relocation SD' },
  { src: 'https://99-marketing.com/wp-content/themes/marketing/assets/img/clients/germandogtrainingcenter.com.png', alt: 'German Dog Training Center' },
  { src: 'https://99-marketing.com/wp-content/themes/marketing/assets/img/clients/greenearthll.com.png', alt: 'Green Earth LL' },
  { src: 'https://99-marketing.com/wp-content/themes/marketing/assets/img/clients/kayscaps.com.png', alt: 'Kays Caps' },
  { src: 'https://99-marketing.com/wp-content/themes/marketing/assets/img/clients/signaturesigninc.com.png', alt: 'Signature Sign Inc' },
  { src: 'https://99-marketing.com/wp-content/themes/marketing/assets/img/clients/tulsapath.com.png', alt: 'Tulsa Path' },
  { src: 'https://99-marketing.com/wp-content/themes/marketing/assets/img/clients/www.alpinemovingco.com.png', alt: 'Alpine Moving Co' },
  { src: 'https://99-marketing.com/wp-content/themes/marketing/assets/img/clients/www.dcruzagency.com.png', alt: 'DCruz Agency' },
  { src: 'https://99-marketing.com/wp-content/themes/marketing/assets/img/clients/www.edc-electrical.com.png', alt: 'EDC Electrical' },
  { src: 'https://99-marketing.com/wp-content/themes/marketing/assets/img/clients/www.integrapersonnel.com.png', alt: 'Integra Personnel' },
];

export default function TrustSection() {
  return (
    <section className="bg-[#f8faf9] py-20 md:py-28">
      <div className="max-w-6xl mx-auto px-4 md:px-8">

        {/* Credibility statement */}
        <div className="bg-[#0d1117] rounded-2xl px-7 md:px-12 py-8 md:py-10 mb-14 text-center">
          <div className="max-w-3xl mx-auto">
            <p className="text-emerald-400 text-xs font-bold tracking-widest uppercase mb-4">Who We Are</p>
            <h2 className="text-2xl md:text-3xl font-black text-white leading-tight mb-3">
              17 Years Growing USA Businesses Online
            </h2>
            <p className="text-white/55 text-base leading-relaxed mb-6">
              We&apos;ve worked with businesses across every major industry — from home services and healthcare to legal and automotive. Our system has generated over 120,000 qualified leads for clients across the country.
            </p>
            <div className="flex flex-wrap justify-center gap-6">
              {[
                { val: '120,000+', label: 'Leads Generated' },
                { val: '500+', label: 'Businesses Served' },
                { val: '97%', label: 'Retention Rate' },
                { val: '4.9★', label: 'Average Rating' },
              ].map((s) => (
                <div key={s.label} className="text-center">
                  <p className="text-emerald-400 text-xl font-black leading-none">{s.val}</p>
                  <p className="text-white/30 text-xs mt-1">{s.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Header */}
        <div className="text-center mb-10">
          <h3 className="text-xl md:text-2xl font-black text-[#0d1117] mb-2">
            Trusted by{' '}
            <span className="bg-gradient-to-r from-emerald-500 to-teal-500 bg-clip-text text-transparent">500+</span>
            {' '}USA-Based Businesses
          </h3>
          <p className="text-[#9ca3af] text-sm">From local service companies to multi-location businesses across every industry.</p>
        </div>

        {/* Real client logos */}
        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-4">
          {clientLogos.map((logo) => (
            <div
              key={logo.alt}
              className="bg-white border border-[#e5e7eb] rounded-xl px-3 py-4 flex items-center justify-center hover:border-emerald-200 hover:shadow-sm transition-all duration-300 group"
            >
              <img
                src={logo.src}
                alt={logo.alt}
                className="max-h-10 w-auto object-contain opacity-70 group-hover:opacity-100 transition-opacity duration-300 grayscale group-hover:grayscale-0"
              />
            </div>
          ))}
        </div>

        {/* Stats row */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-12 pt-10 border-t border-[#e5e7eb]">
          {[
            { value: '97%', label: 'Client retention rate after year one' },
            { value: '3.2x', label: 'Average lead increase in first 90 days' },
            { value: '4.9★', label: 'Average client satisfaction rating' },
          ].map((s) => (
            <div key={s.label} className="text-center">
              <p className="text-3xl md:text-4xl font-black bg-gradient-to-r from-emerald-500 to-teal-500 bg-clip-text text-transparent mb-1">{s.value}</p>
              <p className="text-[#6b7280] text-sm">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
